import { getPath } from './services';
import * as config from './config.json';
export function createAnalytics(eventId) {
    let token = undefined;
    return {
        setToken: (_token) => token = _token,
        event: (category, action, label, value, fields = '', useBeacon = false) => {
            if (!category || !action || !label || typeof value !== 'number') {
                console.warn("Analytics: All fields must be provided", category, action, label, value);
                return;
            }
            const url = getPath('analytics');
            const data = JSON.stringify({
                eventId, category, action, label, value: Math.floor(value), fields, token
            });
            if (useBeacon) {
                const status = navigator.sendBeacon(url, new Blob([data], { type: 'application/json; charset=UTF-8' }));
                if (!status)
                    console.error("Beacon status fail");
                return;
            }
            return fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }
    };
}
export const Analytics = createAnalytics(config.eventId);
export const pevent = Analytics.event;
export const stopwatch = () => {
    const startTime = Date.now();
    return () => ({
        startTime, endTime: Date.now()
    });
};
export const getSeconds = sw => Math.floor((sw.endTime - sw.startTime) / 1000);
